import Tiktok from "./tiktok.container";

export default Tiktok;
